// extracted by mini-css-extract-plugin
export default {"footer":"S_s","row":"S_d4","menu-column":"S_d5"};